import { nanoid } from 'nanoid';

export class IdGeneratorService {
  /**
   * Generates a new unique identifier string.
   */
  generate(): string {
    return nanoid();
  }
}
